<ng-container
  *ngIf="{
    banners: currentBanner$ | async,
    config: carouselConfig$ | async,
  } as content"
>
  <p-carousel
    [value]="content.banners || []"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="content.config?.circular || true"
    [autoplayInterval]="content.config?.autoplayInterval || 0"
    [classList]="'custom-carousel floating-indicator'"
    [responsiveOptions]="responsiveOptions"
  >
    <ng-template pTemplate="item" let-item>
      <cx-banner [item]="item"></cx-banner>
    </ng-template>

    <ng-template pTemplate="previousicon" let-item>
      <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
    </ng-template>

    <ng-template pTemplate="nexticon" let-item>
      <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
    </ng-template>
  </p-carousel>
</ng-container>
